var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-component"
  }, [_c("section", {
    staticClass: "component-iframe"
  }, [_c("div", {
    staticClass: "iframe-bg"
  }, [_c("iframe", {
    attrs: {
      src: _vm.info.component_url,
      id: "component-iframe",
      title: "组件展示"
    }
  }), _c("div", {
    staticClass: "btn_group"
  }, [_c("button", {
    staticClass: "back",
    on: {
      click: _vm.goBack
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/back.png"),
      alt: "返回上级"
    }
  }), _vm._v(" 返回上级 ")])])])]), _c("section", {
    staticClass: "component-detail"
  }, [_c("div", {
    staticClass: "component-name"
  }, [_vm._v(_vm._s(_vm.info.component_name))]), _c("div", {
    staticClass: "component-introduce"
  }, [_vm._v(_vm._s(_vm.info.component_explain))]), _c("ul", {
    staticClass: "component-data"
  }, [_c("li", [_c("span", {
    staticClass: "desc"
  }, [_vm._v("已采购券商")]), _vm.info.landing_customer ? _c("count-to", {
    staticClass: "num",
    attrs: {
      startVal: 0,
      endVal: _vm.info.landing_customer.length,
      duration: 2000,
      autoplay: ""
    }
  }) : _vm._e()], 1), _c("li", [_c("span", {
    staticClass: "desc"
  }, [_vm._v("总调用量")]), _c("count-to", {
    staticClass: "num",
    attrs: {
      startVal: 0,
      endVal: _vm.info.total_usage,
      duration: 2000,
      autoplay: ""
    }
  })], 1)]), _vm.associated_interface.length > 0 && _vm.productType ? _c("section", [_c("p", {
    staticClass: "interface-title"
  }, [_vm._v("关联接口")]), _c("ul", {
    staticClass: "component-interface"
  }, _vm._l(_vm.associated_interface, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "interface-item",
      on: {
        click: function ($event) {
          return _vm.goInterface(item);
        }
      }
    }, [_c("div", {
      staticClass: "interface-content"
    }, [_c("h3", {
      staticClass: "interface-content_title",
      attrs: {
        title: item.interface_name
      }
    }, [_vm._v(_vm._s(item.interface_name))]), _c("h3", {
      staticClass: "interface-content_desc",
      attrs: {
        title: item.short_description
      }
    }, [_vm._v(_vm._s(item.short_description))])])]);
  }), 0)]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };